// extracted by mini-css-extract-plugin
export default {"container":"FormPedido_container__1MHQF","inputsContainer":"FormPedido_inputsContainer__f9BdY"};